import React from "react";
import { FaFacebook, FaTwitter, FaInstagram, FaYoutube } from "react-icons/fa";
import { Link } from "react-router-dom";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-100 text-gray-800 border-t border-gray-300">
      <div className="container mx-auto px-4 py-8">
        {/* Main footer content */}
        <div className="flex flex-col md:flex-row max-md:items-center justify-between mb-6">
          {/* Company info */}
          <div className="mb-6 md:mb-0">
            <h3 className="font-bold max-md:text-center text-[#730000] text-lg mb-3 font-serif cursor-default">
              Select Proposal
            </h3>
            <p className="text-sm text-gray-600 max-w-xs cursor-default">
            Helping find you the proposal of your dreams.

            </p>
          </div>
          <div className="flex flex-col mb-6 max-md:items-center justify-center items-center">
            <img
              src="https://selectproposal.com/public/govt-img-1.jpeg"
              alt=""
              className="w-[102px] flex flex-col max-md:items-start justify-center items-center"
            />
            <p className="text-sm text-gray-600 max-w-xs cursor-default mt-4">
              {" "}
              Registered with Govt of Pakistan
            </p>
          </div>

          {/* Navigation links */}
          <div className="grid grid-cols-2 md:grid-cols- gap-8">
            <div>
              <h4 className="font-semibold mb-3 font-serif cursor-default">
                Company
              </h4>
              <ul className="space-y-2 text-sm">
                <li>
                  <Link to="/about" className="hover:text-blue-600 transition">
                    About us
                  </Link>
                </li>
                <li>
                  <Link to="/blogs" className="hover:text-blue-600 transition">
                    Blog
                  </Link>
                </li>
                <li>
                  <Link
                    to="/contact"
                    className="hover:text-blue-600 transition"
                  >
                    Contact us
                  </Link>
                </li>
              </ul>
            </div>
            <div>
              <h4 className="font-semibold mb-3 font-serif cursor-default">
                Legal
              </h4>
              <ul className="space-y-2 text-sm">
                <li>
                  <Link
                    to="/termAndConditions"
                    className="hover:text-blue-600 transition"
                  >
                    Terms of Use
                  </Link>
                </li>
                <li>
                  <Link
                    to="/termAndConditions"
                    className="hover:text-blue-600 transition"
                  >
                    Privacy Policy
                  </Link>
                </li>
              </ul>
            </div>
            {/* <div>
              <h4 className="font-semibold mb-3 font-serif">Support</h4>
              <ul className="space-y-2 text-sm">
                <li>
                  <Link
                    to="/support"
                    className="hover:text-blue-600 transition"
                  >
                    Help Center
                  </Link>
                </li>
              </ul>
            </div> */}
          </div>
        </div>

        {/* Social media and copyright */}
        <div className="border-t border-gray-200 pt-6 mt-6">
          <div className="flex flex-col md:flex-row md:justify-between items-center">
            <div className="flex space-x-4 mb-4 md:mb-0">
              <Link
                to="https://www.facebook.com/selectproposal/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
                className="text-gray-600 hover:text-blue-600 transition"
              >
                <FaFacebook size={24} />
              </Link>
              <Link
                to="https://www.instagram.com/select.proposal/"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="text-gray-600 hover:text-pink-600 transition"
              >
                <FaInstagram size={24} />
              </Link>
            </div>
            <p className="text-sm text-gray-600 cursor-default">
              © {currentYear} selectProposal.com. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
